import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../shared/context/auth";
import { MyExpRoute } from "./types";
import HeaderWrapper from "../components/headerWrapper";
import MyExpChatBotWrapper from "../components/chatBotWrapper";

export default function AppWrapper() {
  const auth = useAuth();
  if (!auth.isLoggedIn()) {
    return <Navigate to={MyExpRoute.LOGIN.path} replace />;
  }
  return (
    <React.Fragment>
      <HeaderWrapper />
      <MyExpChatBotWrapper />
      <Outlet />
    </React.Fragment>
  );
}
